import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Grid } from "@mzc-pdc/ui";
import Typography from "@components_v2/typography/typography";
import AttributionInputArea from "../../../../components/inputArea/AttributionInputArea";
import {
    addAttribution,
    removeAttribution,
    setValidationError,
    updateAttribution,
} from "@modules/createAsset";

const AttributionsField = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const attributions = useSelector(({ createAsset }) => createAsset.data.attributions);

    const onChangeAttributionValue = (id, value, validationError) => {
        dispatch(
            setValidationError({
                key: `attribution-${id}-value`,
                error: validationError,
            }),
        );

        dispatch(
            updateAttribution({
                id,
                value,
            }),
        );
    };

    const onChangeAttributionKey = (id, key, validationError) => {
        dispatch(
            setValidationError({
                key: `attribution-${id}-key`,
                error: validationError,
            }),
        );

        dispatch(
            updateAttribution({
                id,
                key,
            }),
        );
    };

    const onClickAddAttribution = (id, validationError) => {
        dispatch(addAttribution(id));

        dispatch(
            setValidationError({
                key: `attribution-${id}-key`,
                error: validationError,
            }),
        );

        dispatch(
            setValidationError({
                key: `attribution-${id}-value`,
                error: validationError,
            }),
        );
    };

    const onClickRemoveAttribution = (id) => {
        dispatch(removeAttribution(id));

        dispatch(
            setValidationError({
                key: `attribution-${id}-key`,
                error: null,
            }),
        );

        dispatch(
            setValidationError({
                key: `attribution-${id}-value`,
                error: null,
            }),
        );
    };

    return (
        <Grid container alignItems={"center"} mb={2.5}>
            <Grid item sx={{ alignSelf: "flex-start", minWidth: "244px" }} alignItems={"center"}>
                <Typography variant={"body1"} component={"p"} mt={"10px"}>
                    {t(`common::label::Attributions`, `Attributions`)}
                </Typography>
            </Grid>
            <Grid
                item
                sx={{
                    flex: 1,
                    alignSelf: "flex-start",
                    maxWidth: "1000px",
                }}
            >
                <AttributionInputArea
                    values={attributions}
                    onChangeKey={onChangeAttributionKey}
                    onChangeValue={onChangeAttributionValue}
                    onClickAddAttribution={onClickAddAttribution}
                    onClickRemoveAttribution={onClickRemoveAttribution}
                />
            </Grid>
        </Grid>
    );
};

export default AttributionsField;
